/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import {makeStyles} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page


import componentsStyle from "assets/jss/material-kit-pro-react/views/componentsStyle.js";
import BaseHeader from "./BaseView/BaseHeader";
import WelcomeDescription from "./welcome/WelcomeDescription";
import WelcomeAnimation from "./welcome/WelcomeAnimation";
import BaseFooter from "./BaseView/BaseFooter";
import WelcomeFree from "./welcome/WelcomeFree";
import WelcomePrice from "./welcome/WelcomePrice";
import Clearfix from "../components/Clearfix/Clearfix";
import {utm} from "../utils/request";

import intl from 'react-intl-universal';

const useStyles = makeStyles(componentsStyle);


function Components() {
	React.useEffect(() => {
		var href = window.location.href.substring(
			window.location.href.lastIndexOf("#") + 1
		);
		if (window.location.href.lastIndexOf("#") > 0) {
			document.getElementById(href).scrollIntoView();
		}
	});
	const easeInOutQuad = (t, b, c, d) => {
		t /= d / 2;
		if (t < 1) return (c / 2) * t * t + b;
		t--;
		return (-c / 2) * (t * (t - 2) - 1) + b;
	};
	const smoothScroll = target => {
		var targetScroll = document.getElementById(target);
		scrollTo(document.documentElement, targetScroll.offsetTop - 200, 900);
	};
	const scrollTo = (element, to, duration) => {
		var start = element.scrollTop,
			change = to - start + document.getElementById("main-panel").offsetTop,
			currentTime = 0,
			increment = 20;

		var animateScroll = function () {
			currentTime += increment;
			var val = easeInOutQuad(currentTime, start, change, duration);
			element.scrollTop = val;
			if (currentTime < duration) {
				setTimeout(animateScroll, increment);
			}
		};
		animateScroll();
	};
	const classes = useStyles();
	return (
		<div>
			<BaseHeader fixed/>


			<Parallax filter={"dark"}
					  image={"https://robinalgo.oss-cn-shanghai.aliyuncs.com/welcome_bg.jpg"}>
				<div className={classes.container}>
					<GridContainer>
						<GridItem xs={12} sm={12} md={6}>
							<h1 className={classes.title}>{intl.get('robin_desc')}</h1>
							<h4 style={{color: '#fff'}}>
								{intl.get('welcome_info_1')}<u>{intl.get('video')}</u>,
								{intl.get('welcome_info_2')}<u>{intl.get('welcome_info_3')}</u>{intl.get('adn')}<u>{intl.get('welcome_info_4')}</u>{intl.get('welcome_info_5')}
							</h4>
							<br/>
							<Button
								color="rose"
								size="lg"
								href="/signUp"
								rel="noopener noreferrer"
							>
								<Favorite/>
								&nbsp;&nbsp;&nbsp;&nbsp;{intl.get('join_us')}
							</Button>
							<Button
								color="primary"
								size="lg"
								href="http://mp.weixin.qq.com/s?__biz=MzIyNTUwOTEwOQ==&mid=100000045&idx=1&sn=a51a41a13285e82c5f80aa7bbb8482ea&chksm=687feab75f0863a13b9dae1ce677ef62195a8db0c2d3e45a68c0c6ca3dfe0618644cdf392a41#rd"
								target="_blank"
								rel="noopener noreferrer"
								style={{marginLeft: '24px'}}
							>
								<PlayCircleFilledIcon/>
								&nbsp;&nbsp;&nbsp;&nbsp;{intl.get('introduction_video')}
							</Button>
						</GridItem>
					</GridContainer>
				</div>
			</Parallax>

			<div
				className={classNames(classes.main, classes.mainRaised)}
				id="main-panel"
			>
				<WelcomeDescription/>
				<WelcomeFree/>

				<WelcomePrice/>
				<WelcomeAnimation/>
			</div>


			<nav id="cd-vertical-nav">
				<ul>
					<li>
						<a
							href="#WelcomeDescription"
							data-number="1"
							className=""
							onClick={e => {
								e.preventDefault();
								smoothScroll("WelcomeDescription");
							}}
						>
							<span className="cd-dot"/>
							<span className="cd-label">{intl.get('introduction')}</span>
						</a>
					</li>
					<li>
						<a
							href="#WelcomeFree"
							data-number="2"
							className=""
							onClick={e => {
								e.preventDefault();
								smoothScroll("WelcomeFree");
							}}
						>
							<span className="cd-dot"/>
							<span className="cd-label">{intl.get('animation_video')}</span>
						</a>
					</li>
					<li>
						<a
							href="#WelcomePrice"
							data-number="3"
							className=""
							onClick={e => {
								e.preventDefault();
								smoothScroll("WelcomePrice");
							}}
						>
							<span className="cd-dot"/>
							<span className="cd-label">{intl.get('subscription_content')}</span>
						</a>
					</li>
					<li>
						<a
							href="#WelcomeAnimation"
							data-number="4"
							className=""
							onClick={e => {
								e.preventDefault();
								smoothScroll("WelcomeAnimation");
							}}
						>
							<span className="cd-dot"/>
							<span className="cd-label">{intl.get('more_info')}</span>
						</a>
					</li>
				</ul>
			</nav>
			<BaseFooter/>
		</div>
	);
}



class Welcome extends React.Component{


	constructor(props, context) {
		super(props, context);
		const utm = this.props.match.params.utm;

		if (utm === undefined) {

		} else {
			this.upUtm(utm);
		}
	}

	upUtm = (_utm) => {
		utm(_utm).then()
	};

	render() {
		return(
			<Components/>
		)
	}

}
export default Welcome

